import React, { useState } from 'react';
import { CourseModuleAboutCardMaterial } from './course-module-about-card-material';
import { EmptyState } from '@/components/custom/empty-state';
import { t } from 'i18next';
import { Filter, FilterInput } from '@/components/custom/filter';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export function CourseModuleAboutTabFiles({ currentModule }) {
  const [searchTerm, setSearchTerm] = useState('');

  const moduleLessons = currentModule?.['learning-system-contents']
    ?.map(content =>
      content.learning_system_items.map(item => {
        return item;
      })
    )
    .flat();

  const filteredFiles = currentModule?.['learning-system-files']?.filter(file => {
    if (searchTerm == '') {
      return file;
    }
    if (file.title !== null && file.title.toLowerCase().includes(searchTerm.toLocaleLowerCase())) {
      return file;
    }
  });

  return (
    <div className="animate-fade-in">
      <Filter>
        <FilterInput
          label={t('textsCommon.search')}
          placeholder={t('filter.labelSearchFiles')}
          type="search"
          name="search"
          id="search"
          onChange={e => setSearchTerm(e.target.value)}
        />
      </Filter>

      {filteredFiles && filteredFiles?.length > 0 ? (
        <Table className="min-w-[700px]">
          <TableHeader>
            <TableRow>
              <TableHead scope="col">Nome do material</TableHead>
              <TableHead
                scope="col"
                className="w-[160px]"
              >
                Aula
              </TableHead>
              <TableHead
                scope="col"
                className="w-[140px]"
              />
            </TableRow>
          </TableHeader>

          <TableBody>
            {filteredFiles?.map(material => {
              return (
                <CourseModuleAboutCardMaterial
                  material={material}
                  moduleLessons={moduleLessons}
                  currentModule={currentModule}
                  key={material?.id}
                />
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <EmptyState type="data" />
      )}
    </div>
  );
}
